const originalGetMapPanePos = (L.Map.prototype as any)._getMapPanePos;

L.Map.include({
  _getMapPanePos: function () {
    if (this._mapPane) return originalGetMapPanePos.call(this);
    else return new L.Point(0, 0);
  }
});
